var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogonotext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 121.12 122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#672783;}.cls-2{fill:#312c82;}.cls-3{fill:#39aae1;}.cls-4{fill:#9bb51f;}.cls-5{fill:#e78501;}.cls-6{fill:#d90272;}.cls-7{fill:#d20d52;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59,46.26c-2.55-15,15.87-27.9,15.87-27.9,5.94-2.94,9.13.48,9.13.48,0,17.29,15.54,12.41,15.54,12.41,6.18,3.27,2.5,11.92,2.5,11.92a30.46,30.46,0,0,0-17-.92c-9.09-28.56-26,4-26,4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.62,14A8.56,8.56,0,0,1,89.94,27.38,8.56,8.56,0,0,1,100.62,14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.2,52.87c-13.34-7.38-11.91-29.8-11.91-29.8,1.41-6.48,6.08-6.84,6.08-6.84C53.91,27,59.75,11.82,59.75,11.82,66.17,9,70.64,17.31,70.64,17.31A30.43,30.43,0,0,0,59.29,30.05C31.3,19.33,46.2,52.87,46.2,52.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47,.2A8.46,8.46,0,0,1,57,6.71,8.33,8.33,0,1,1,40.74,10.4,8.45,8.45,0,0,1,47,.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.1,64.54C30,70.36,13.38,55.25,13.38,55.25c-4.18-5.14-1.56-9-1.56-9,16.85-3.88,8.66-17.9,8.66-17.9,1.83-6.76,11.08-5.08,11.08-5.08a30.42,30.42,0,0,0,2.87,16.81C8.6,55.26,44.1,64.54,44.1,64.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3.42,31.09a8.44,8.44,0,0,1,11.33-3.78A8.33,8.33,0,1,1,3.42,31.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52.33,75.13C48.09,89.77,25.9,93.34,25.9,93.34c-6.63.06-8-4.41-8-4.41C25.37,73.34,9.29,71,9.29,71c-4.13-5.64,2.94-11.83,2.94-11.83a30.46,30.46,0,0,0,14.94,8.25c-4.24,29.67,25.16,7.71,25.16,7.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M.8,86.05A8.46,8.46,0,0,1,4.92,74.83a8.34,8.34,0,1,1,7.2,15A8.45,8.45,0,0,1,.8,86.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66.51,74.71c8.8,12.44-2.25,32-2.25,32-4.09,5.22-8.45,3.52-8.45,3.52-7.51-15.57-19.37-4.47-19.37-4.47-7-.29-7.41-9.68-7.41-9.68a30.43,30.43,0,0,0,15.76-6.53c20.54,21.83,21.72-14.85,21.72-14.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42.9,121.79a8.56,8.56,0,1,1,10-6.47,8.44,8.44,0,0,1-10,6.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M74.05,64.63c15.21.88,23.61,21.73,23.61,21.73,1.53,6.45-2.52,8.79-2.52,8.79C78.28,91.31,79.56,107.5,79.56,107.5c-4.59,5.29-12.19-.25-12.19-.25a30.45,30.45,0,0,0,4.74-16.39c29.87-2.43,1.94-26.23,1.94-26.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M96.11,112.45a8.56,8.56,0,1,1,1.21-11.88,8.44,8.44,0,0,1-1.21,11.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M70,51c10.19-11.34,31.72-4.9,31.72-4.9,6,2.83,5.3,7.46,5.3,7.46-13.52,10.78-.07,19.88-.07,19.88,1.27,6.88-7.8,9.37-7.8,9.37a30.45,30.45,0,0,0-9.86-13.92C106,44,70,51,70,51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M121.12,63.56a8.56,8.56,0,1,1-8.53-8.36,8.44,8.44,0,0,1,8.53,8.36"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogonotext);
export default __webpack_public_path__ + "static/media/Logo no text.53045fb4f91fcc7870015bd58034d80a.svg";
export { ForwardRef as ReactComponent };